import React from 'react';
import { Link } from 'react-router-dom';

import './LandscapeMessage.scss';

const LandscapeMessage = ({ }) => {
 return <div className="landscapeMessage">
    <div>This site is optimized for portrait orientation on mobile. Please rotate your device.</div>
  </div>
};

export default LandscapeMessage;
